import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Validation from '../../../shared/Validation';
import MaskedInput from 'react-text-mask';
import Logout from '../../../shared/Logout/Logout';
import FloatingError from '../../../shared/FloatingError/FloatingError';
import classNames from 'classnames';

import './EnrollSingleInput.scss';
import imprivataIcon from '../../Login/Icons/imprivata.svg';

class EnrollSingleInput extends Component {
  static propTypes = {
    /** The header text for this enrollment screen */
    headerTitle: PropTypes.string,
    /** Input placeholder text */
    placeholderText: PropTypes.string,
    /** Text that is displayed underneath the input as a hint */
    inputHint: PropTypes.string,
    /** The type of input (password, text, or phone) for the input control */
    inputType: PropTypes.oneOf([
      'password', 'text', 'phone', 'number',
    ]),
    /** Determines if the user can skip the enrollment process - shows the 'Do this later' link */
    canSkipEnrollment: PropTypes.bool,
    /** The text to be displayed underneath the enrollment input */
    linkText: PropTypes.string,
    /** The function that is executed when the link is clicked */
    onLinkClicked: PropTypes.func,
    /** Function to be executed when you skip */
    onSkipEnroll: PropTypes.func,
    /** The function that is executed when the input is changed */
    onInputChange: PropTypes.func,
    /** The function that is executed when the form is submitted */
    onSubmit: PropTypes.func,
    /** The text for the submit button */
    submitText: PropTypes.string,
    /** Validation constraints object for validate.js
    (https://validatejs.org/#constraints) */
    validation: PropTypes.object,
    /** Errors to display inside of component from a parent component */
    displayErrors: PropTypes.arrayOf(PropTypes.string),
    /** Maximum length of value in input or blank for no maximum */
    maxLength: PropTypes.string,
    /** Whether the browser should attempt to autoComplete the field */
    autoComplete: PropTypes.bool,
    /** Whether the field should automatically gain focus */
    autoFocus: PropTypes.bool,
    /** Value of the input box */
    input: PropTypes.string,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    standardMessage: PropTypes.string,
  };
  static defaultProps = {
    headerTitle: 'Enroll SMS code',
    placeholderText: 'e.g. (000) 000-0000',
    inputHint: '',
    inputType: PropTypes.text,
    submitText: 'Submit',
    validation: { input: { presence: true, }, },
    displayErrors: [],
    autoComplete: false,
    autoFocus: false,
    input: '',
    logoutComponent: <Logout/>,
    onInputChange: () => void(0),
    onSubmit: () => void(0),
    maxLength: '',
  };
  constructor(props) {
    super(props);
    this.validation = new Validation(props.validation);
    this.state = {
      errors: '',
      showErrors: false,
      input: props.input,
      disableSubmit: true,
    };
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.input !== prevProps.input) {
      this.setState({ input: this.props.input, });
    }
  };
  changeInput = (event) => {
    const inputValues = { input: event.target.value.trim(), };
    if (this.props.inputType === 'number') {
      const isPositiveInteger = RegExp('^[0-9]*$').test(inputValues.input);
      if (!isPositiveInteger) {
        event.preventDefault();
        return;
      }
    }
    this.validation.updateValues(inputValues);
    inputValues.disableSubmit = this.validation.hasErrors();
    inputValues.errors = this.validation.errorMessages();
    inputValues.showErrors = false;
    this.setState(inputValues);
    this.props.onInputChange(inputValues);
  };
  submitForm = (event) => {
    event.preventDefault();
    if (this.state.errors) {
      this.setState({ showErrors: true, });
    }
    else {
      this.setState({ showErrors: false, });
      this.props.onSubmit(this.state);
    }
  };
  render() {
    const formClasses = classNames({
      'form-control': true,
      'form-error-outline': this.props.displayErrors.length > 0,
    });
    return (
      <div className='CIDRA'>
        {this.props.logoutComponent}
        <div className='login-container'>
          <form
            id='EnrollSingleInput_form'
            className='form'
            onSubmit={this.submitForm}>

            <div className='form-group login-header'>
              {
                this.props.headerTitle ? (
                  <h2 id='EnrollSingleInput_header_title' className='header-title'>
                    {this.props.headerTitle}
                  </h2>
                ) : null
              }
            </div>
            <br/>
            <div className='form-group'>

              {this.props.children}
              <br/>
              {
                this.props.headerTitle === 'Check your phone' ? (
                  // eslint-disable-next-line
                  <div> Not the right number? <a id='EnrollIntroduction_Edit_Button' className='EditPhoneButton' onClick={this.props.onLinkClicked}> Edit phone number</a></div>
                ) : null
              }
            </div>
            <br/>
            {this.props.displayErrors.length > 0 ?
              (
                <div>
                  <FloatingError messages={this.props.displayErrors}/>
                </div>
              )
              : null
            }
            <div className={ this.props.inputHint ? 'form-group no-margin-bottom' : 'form-group' }>
              {
                this.props.inputType === 'phone' ? (
                  <MaskedInput
                    mask={[
                      '(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,
                    ]}
                    guide={false}
                    autoFocus={this.props.autoFocus}
                    id='EnrollSingleInput_input'
                    type='text'
                    autoComplete={this.props.autoComplete ? 'on' : 'off'}
                    className={formClasses}
                    placeholder={this.props.placeholderText}
                    name='input'
                    onChange={this.changeInput}
                    value={this.state.input}
                  />
                ) : (
                  <input
                    autoFocus={this.props.autoFocus}
                    id='EnrollSingleInput_input'
                    type={this.props.inputType === 'number' ? 'text' : this.props.inputType}
                    className={formClasses}
                    placeholder={this.props.placeholderText}
                    name='input'
                    onChange={this.changeInput}
                    autoComplete={this.props.autoComplete ? 'on' : 'off'}
                    value={this.state.input}
                    maxLength={this.props.maxLength}
                  />
                )
              }
            </div>
            {
              this.props.inputHint ? (
                <div className='form-group'>
                  <span id='EnrollSingleInput_input_hint' className='input-hint-text'>
                    {this.props.inputHint}
                  </span>
                </div>
              ) : null
            }
            {
              this.props.standardMessage ? (
                <div className='form-group'>
                  <span id='EnrollSingleInput_input_hint' className='input-hint-text'>
                    {this.props.standardMessage}
                  </span>
                </div>
              ) : null
            }
            <div className='form-group single-input-submit'>
              <input
                id='EnrollSingleInput_submit_button'
                className='btn btn-primary btn-block'
                type='submit'
                value={this.props.submitText}
                disabled={this.state.disableSubmit}
                onClick={this.submitForm}
              />
            </div>
            {
              this.props.linkText ? (
                <div className='text-center'>
                  {
                    // eslint-disable-next-line
                  }<a id='EnrollIntroduction_link_DoThisLater' className='btn btn-link' onClick={this.props.onSkipEnroll}>
                    {this.props.linkText}
                  </a>
                </div>
              ) : null
            }

          </form>
        </div>
        { this.props.footer }
        <hr className='Footer-hr'/>
        <img className='Footer' src={imprivataIcon} alt='logo'/>
      </div>
    );
  }
}

export default EnrollSingleInput;
